import React, { useState, useEffect, useRef } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result, set } from 'lodash';
import joi from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Result, Select } from 'antd';
import 'antd/dist/antd.css';
import { useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp, faCamera } from '@fortawesome/free-solid-svg-icons';
import HighSpeedDataType from '../Common/HighSpeedDataType';
import MultipleImageUploadWithRemarks from '../utill/ImageUploadComponent';
import { Typography } from '@mui/material';
import AccordianComp from '../Common/AccordianComp';
import { el } from 'date-fns/locale';
const MainReport = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, Heading }) => {
  const history = useHistory();
  const location = useLocation();

  const [qualityData, setQualityData] = useState([])
  const [selectedInspection, setSeletedInspection] = useState({})
  const [inputData, setInputData] = useState({ DateTime: new Date(), Instrument: [], CustomFields: [] })
  const [loader, setLoader] = useState(false)
  const [methods, setMethods] = useState([])
  const [FinalResult, setFinalResult] = useState([])
  const [NumberOfSample, setNumberOfSample] = useState(0)
  const [NumberOfSet, setNumberOfSet] = useState(0)
  const [sampleStartIndex, setSampleStartIndex] = useState(0)

  const [imageURL, setImageURL] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [ModalImage, setModalImage] = useState('');
  const [List, setList] = useState([]);
  const [files, setFiles] = useState([]);
  const [templateList, setTemplateList] = useState([])
  const [columns, setSelectedColumns] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] })
  const [errors, setErrors] = useState({});
  const [checkSheetFieldError, setChecksheetFieldError] = useState({})
  const [Enable, setEnable] = useState(true)
  const [RuleData, setRuleData] = useState([])
  const [constantFields, setConstantFields] = useState([])
  const [specimenRefCode, setSpecimenRefCode] = useState([])
  const [notApplicableState, setNotApplicableState] = useState({})
  const [remarksState, setRemarksState] = useState({})

  const [itemList, setItemList] = useState([]);
  const [inspectionMasterList, setInspectionMasterList] = useState([])

  const [instruments, setInstruments] = useState([]);
  const [types, setTypes] = useState([]);

  const [ChecksheetType, setCheckSheetType] = useState("")
  const [config, setConfig] = useState({})

  const [item, setItem] = useState({})
  const [obj, setObj] = useState({})
  const [focusedInput, setFocusedInput] = useState('')
  const [ImageURLData, setImageURLData] = useState([])





  const inputRefs = useRef([]);
  console.log(inputRefs, "inucgjehgputRefs")
  const handleFocusNext = (key) => {
    // Focus on the next input field
    console.log('Entering focus', key, inputRefs);
    if (inputRefs.current[key]) {
      inputRefs.current[key].focus();
    }
  };



  const initializedInputFocus = () => {
    // Ensure the focus happens after the component has mounted
    const timer = setInterval(() => {
      if (inputRefs.current["0-0-high_speed_string"]) {
        inputRefs.current["0-0-high_speed_string"].focus();
        clearInterval(timer);
      }
      else if (inputRefs.current["0-custom"] && config.SampleSerial == "Manual") {
        inputRefs.current["0-custom"].focus();
        clearInterval(timer);
      } else {
        if (inputRefs.current["0-custom"]) {
          inputRefs.current["0-custom"].focus();
          clearInterval(timer);
        }
      }
    }, 1);

    // return () => clearInterval(timer); // Cleanup the timer on component unmount
  }

  useEffect(() => {
    if (location.state) {
      setObj(location.state.obj)
      setItem(location.state.item)
      setCheckSheetType(location.state.ChecksheetType)
      setConfig(location.state.config)
    }
  }, [location.state])

  useEffect(() => {
    if (templateList.length > 0 && itemList.length > 0 && inspectionMasterList.length > 0) {
      getAllTypes()
      getAllInstrument()
      initializedData()
    }
  }, [obj, templateList, itemList, inspectionMasterList])

  useEffect(() => {
    getListNames()
    getAllcheckPointConfig();
    getAllInspections();
    getAllItems();
    GetAllRules();
  }, [])
  const GetAllRules = () => {
    axios.get(api.api + 'RuleMaster')
      .then((result) => {
        // consol(result.data)
        setRuleData(result.data);
      })
      .catch((err) => {
        swal(`${err}`)
        // setLoader(false)
      })
  }
  useEffect(() => {
    initializedInputFocus()
  }, [config])
  useEffect(() => {
    Heading(ChecksheetType + ' Report')
  }, [ChecksheetType])


  const getAllcheckPointConfig = () => {
    axios.get(api.api + "checkPointConfig")
      .then((result) => {
        setTemplateList(result.data || [])
      })
      .catch((err) => {
        swal(`${err}`);
      })
  }

  const getAllItems = () => {
    axios.get(api.api + "item")
      .then((result) => {
        setItemList(result.data)
      })
      .catch((err) => {
        swal(`${err}`);
      })
  }

  const getAllInspections = () => {
    axios.get(api.api + "customInspection")
      .then((result) => {
        setInspectionMasterList(result.data)
      })
      .catch((err) => {
        swal(`${err}`);
      })
  }



  const getAllTypes = () => {
    axios.get(api.api + 'instrumentType')
      .then((result) => {
        setTypes(result.data.map((x) => { return { label: x.InstrumentType, value: x.InstrumentType, _id: x._id } }))
      })
      .catch((err) => {
        swal(`${err}`)
      })
  }

  const getAllInstrument = () => {
    axios.get(api.api + 'instrument')
      .then((result) => {
        setInstruments(result.data.map((x) => { return { type: x.InstrumentType, label: x.Instrument, value: x.Instrument, _id: x._id } }))
      })
      .catch((err) => {
        swal(`${err}`)
      })
  }

  const getNextSample = (input) => {
    // Separate the string and number
    const match = input.match(/([a-zA-Z]+)(\d+)/);

    if (match) {
      const stringPart = match[1]; // "Sample"
      const numberPart = parseInt(match[2], 10); // 1

      // Increment the number
      const incrementedNumber = numberPart + 1;

      // Combine the string part with the incremented number
      return incrementedNumber; // "Sample2"
    } else {
      return 0; // Return the original input if no match is found
    }
  }

  const getSampleNumber = (input) => {
    // Separate the string and number
    const match = input.match(/([a-zA-Z]+)(\d+)/);

    if (match) {
      const stringPart = match[1]; // "Sample"
      const numberPart = parseInt(match[2], 10); // 1

      // Increment the number
      const incrementedNumber = numberPart;

      // Combine the string part with the incremented number
      return incrementedNumber; // "Sample2"
    } else {
      return 0; // Return the original input if no match is found
    }
  }

  const getNewCheckSheetObj = (setName, checkSheetIdx) => {
    const cloneItem = cloneDeep(itemList.find(x => x._id == item._id))
    const checkSheet = cloneItem && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
    if (checkSheet && checkSheet.checkSheetTitle) {
      const default1 = config.ResultConfigure.find(x => x.Result == config.DefaultSelection)
      checkSheet.checkSheetTitle[checkSheetIdx].checkpoints.forEach((x) => {
        if (x.StandardType == "Dimension") {
          x.Result = "NG";
          x.ResultLabel = "NG";
        } else {
          x.Result = default1.TreatAs;
          x.ResultLabel = default1.Result;
        }
      })
      return { setName: setName, Standard: checkSheet.checkSheetTitle[checkSheetIdx].checkpoints };
    }
    return { Standard: [] }
  }


  async function fileFromBase64(base64, fileName) {
    try {
      // Split the base64 string to get the metadata part (before the comma)
      const base64Parts = base64.split(',');

      // Extract the MIME type from the first part of the base64 string (e.g., "data:image/png;base64")
      const mimeMatch = base64Parts[0].match(/:(.*?);/);
      const fileType = mimeMatch ? mimeMatch[1] : ''; // Extract the MIME type

      // Decode the base64 string to a binary string
      const binaryString = window.atob(base64Parts[1]);

      // Create a Uint8Array to store the binary data
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      // Map the binary string data to the Uint8Array
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create a Blob from the array buffer
      const blob = new Blob([bytes], { type: fileType });

      // Create a File object from the Blob
      const file = new File([blob], fileName, { type: fileType });

      return file;
    } catch (error) {
      console.error('Error converting base64 to file:', error);
      return null;
    }
  }

  const loadFilesFromUrls = async (all = []) => {
    const processFiles = all.filter(x => x.FilePath)
    let validFiles = []
    if (processFiles.length > 0) {
      const fileListPromises = processFiles.map((file) => fileFromBase64(file.FilePath, file.DocTitle));
      const fetchedFiles = await Promise.all(fileListPromises);
      // Filter out any null files in case of errors during fetch
      validFiles = fetchedFiles.filter((file) => file !== null);

    }
    return [...all.filter(x => !x.FilePath), ...validFiles]

  };

  const initializedData = async () => {
    if (location.state && location.state.action == "edit") {
      const cloneItem = cloneDeep(itemList.find(x => x._id == item._id))
      setItem(cloneItem)
      const checkSheet = cloneItem && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
      if (!checkSheet || (checkSheet && !checkSheet.checkSheetTitle)) {
        if (ChecksheetType) {
          swal(`Do not have checkpoints for ${ChecksheetType} `, { dangerMode: true })
          history.goBack();
        } else {
          history.push("/DataEntry/not_found");
        }

      } else {
        if (checkSheet.checkSheetTitle && checkSheet.checkSheetTitle && checkSheet.checkSheetTitle.length > 0) {
          checkSheet.ConstantFields.forEach((x => {
            if (location.state.obj.customFields) {
              const fieldValue = location.state.obj.customFields.find(val => val.FieldName == x.FieldName)
              if (fieldValue && fieldValue.Value) {
                x.Value = fieldValue.Value
              } else {
                x.Value = ""
              }
            }
          }))
          setConstantFields(checkSheet.ConstantFields)
          const template = templateList.find(x => checkSheet.checkSheetTitle.some(a => a.TemplateName == x.Name));
          if (template) {
            setSelectedTemplate(template)
            /// setSelectedColumns(template.Columns.filter(col => col.EnableForDataEntry) || [])
          }
          let config1 = inspectionMasterList.find(x => x._id == config._id)
          setConfig(config1)
          const default1 = config.ResultConfigure.find(x => x.Result == config.DefaultSelection)
          // const finalResult = [...FinalResult];
          // const result = [{ Sample: "", Value: default1.TreatAs }]
          const result = checkSheet.checkSheetTitle.map((check) => location.state.obj.sampleRef.filter(x => x.CheckSheetName == check.check_sheet_title))
          setFinalResult(result);

          // checkSheet.checkSheetTitle.checkpoints.forEach((x) => {
          //   if (x.StandardType == "Dimension") {
          //     x.Result = "NG";
          //     x.ResultLabel = "NG";
          //   } else {
          //     x.Result = default1.TreatAs;
          //     x.ResultLabel = default1.Result;
          //   }
          // })
          const inputObj = { ...location.state.obj };
          const refDocs = await loadFilesFromUrls(inputObj.RefDocs)
          setImageURL(refDocs)
          setSpecimenRefCode(inputObj.RefSpecimenInput || [])
          inputObj.CustomFields = []
          if (config1.SampleSerial == "Auto" && config1.SampleSerialUnique == "Yes") {
            // const res = await axios.put(api.api + "LastSampleSerial", { InspectionType: ChecksheetType, ItemName: cloneItem.ItemName });
            // const carryRes = await axios.put(api.api + "LastSampleSerial", { InspectionType: ChecksheetType, ItemName: cloneItem.ItemName, RequestType: "CarryForward" });
            // const nextSample = getNextSample(res.data.Sample)

            const nextSample = getSampleNumber(location.state.obj.sampleRef[0].Sample)
            setSampleStartIndex(nextSample - 1)
          }
          config1.CustomFields.filter(x => !x.Constant).forEach((one) => {
            const findValue = location.state.obj.customFields.find(x => x.FieldName == one.FieldName)
            if (findValue) {
              inputObj.CustomFields.push({ FieldName: one.FieldName, Value: findValue.Value, DataType: one.DataType })
            } else {
              inputObj.CustomFields.push({ FieldName: one.FieldName, Value: "", DataType: one.DataType })
            }
          })
          setInputData(inputObj);
          const arrOfCheckSheet = checkSheet.checkSheetTitle.map((checksheet, checkSheetIdx) => {
            const checkSheets = location.state.obj.sampleRef.filter(x => x.CheckSheetName == checksheet.check_sheet_title).map((checkRef, idx) => {
              let deepClonedChecksheet = JSON.parse(JSON.stringify(location.state.obj.Checksheet));
              deepClonedChecksheet = deepClonedChecksheet.filter(item => item.CheckSheetName == checkRef.CheckSheetName)
              deepClonedChecksheet.forEach((check) => {
                const keys = Object.keys(check.Data[idx]);
                keys.forEach((key) => {
                  check[key] = check.Data[idx][key];
                });
              });
              return { SetName: deepClonedChecksheet[0].SetName, Standard: deepClonedChecksheet };
            });
            return { CheckSheetName: checksheet.check_sheet_title, TemplateName: checksheet.TemplateName, Drawing: checksheet.Drawing, Samples: checkSheets };
          })

          setInputData(inputObj);
          setSeletedInspection(checkSheet)
          setEnable(checkSheet.EnableSet)
          setQualityData(arrOfCheckSheet);
        }
        setNumberOfSample(checkSheet.checkSheetTitle.reduce((total, x) => total + x.NumOfSamples, 0));
        setNumberOfSet(checkSheet.NumberOfSet || 0)
      }
    } else {
      const cloneItem = cloneDeep(itemList.find(x => x._id == item._id))
      setItem(cloneItem)
      const checkSheet = cloneItem && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
      if (!checkSheet || (checkSheet && !checkSheet.checkSheetTitle)) {
        if (ChecksheetType) {
          swal(`Do not have checkpoints for ${ChecksheetType} `, { dangerMode: true })
          history.goBack();
        } else {
          history.push("/DataEntry/not_found");
        }

      } else {
        if (checkSheet.checkSheetTitle && checkSheet.checkSheetTitle && checkSheet.checkSheetTitle.length > 0) {
          setConstantFields(checkSheet.ConstantFields)
          const template = templateList.find(x => checkSheet.checkSheetTitle.some(a => a.TemplateName == x.Name));
          if (template) {
            setSelectedTemplate(template)
            setSelectedColumns(template.Columns.filter(col => col.EnableForDataEntry) || [])
            //setSelectedColumns(template.Columns.map(col => col) || [])

          }
          let config1 = inspectionMasterList.find(x => x._id == config._id)
          setConfig(config1)
          const default1 = config.ResultConfigure.find(x => x.Result == config.DefaultSelection)
          //const result = [{ Sample: "", Value: default1.TreatAs }]

          checkSheet.checkSheetTitle.forEach(check => {
            if (check.checkpoints) {
              check.checkpoints.forEach((x) => {
                if (x.StandardType == "Dimension") {
                  x.Result = "NG";
                  x.ResultLabel = "NG";
                } else {
                  x.Result = default1.TreatAs;
                  x.ResultLabel = default1.Result;
                }
              })
            }
          })

          const result = checkSheet.checkSheetTitle.map((x) => {
            return [{ Sample: "", Value: handelfinalResult(x.checkpoints), CheckSheetName: x.check_sheet_title }]
          })
          if (checkSheet.EnableSet) {
            const finalSets = []
            checkSheet.checkSheetTitle.forEach((check, idx) => {
              let sets = [];
              if (check.SetApplicable) {
                checkSheet.SetNames && checkSheet.SetNames.forEach((x) => {
                  sets = [...sets, ...Array(check.NumOfSamples).fill({ Sample: "", Value: handelfinalResult(check.checkpoints), SetName: x.value, CheckSheetName: check.check_sheet_title })]
                })
              } else {
                sets = [...sets, ...Array(check.NumOfSamples).fill({ Sample: "", Value: handelfinalResult(check.checkpoints), SetName: "", CheckSheetName: check.check_sheet_title })]
              }
              finalSets.push(sets);
            })
            setFinalResult(finalSets);
          } else {

            setFinalResult(result);
          }


          const inputObj = { ...inputData };
          inputObj.CustomFields = []
          if (config1.SampleSerial == "Auto" && config1.SampleSerialUnique == "Yes") {
            const res = await axios.put(api.api + "LastSampleSerial", { InspectionType: ChecksheetType, ItemName: cloneItem.ItemName });
            const carryRes = await axios.put(api.api + "LastSampleSerial", { InspectionType: ChecksheetType, ItemName: cloneItem.ItemName, RequestType: "CarryForward" });
            const nextSample = getNextSample(res.data.Sample)
            config1.CustomFields.filter(x => !x.Constant).forEach((one) => {
              const findValue = carryRes.data.customFields.find(x => x.FieldName == one.FieldName)
              if (findValue) {
                inputObj.CustomFields.push({ FieldName: one.FieldName, Value: findValue.Value, DataType: one.DataType })
              } else {
                inputObj.CustomFields.push({ FieldName: one.FieldName, Value: "", DataType: one.DataType })
              }
            })
            setSampleStartIndex(nextSample - 1)
          }
          setInputData(inputObj);
          setSeletedInspection(checkSheet)
          setEnable(checkSheet.EnableSet)
          if (checkSheet.EnableSet) {
            const setEnableCheckSheet = checkSheet.checkSheetTitle.map((check, checkIdx) => {
              if (check.SetApplicable) {
                const SetSample = checkSheet.SetNames.map(name => ({
                  SetName: name.setName,
                  Standard: Array(check.NumOfSamples).fill().map(() => (
                    //Array(1).fill().map(checkpoint => (
                    {
                      SetName: name.value, // Include SetName inside each Standard object
                      Standard: check.checkpoints.map(checkpoint => ({
                        ...checkpoint, // Spread the existing checkpoint properties
                        SetName: name.value // Include SetName in each checkpoint object
                      }))
                    }
                    // ))
                  )).flat() // Flatten the array so all standards are in one list
                }));
                let arr = []
                SetSample.forEach(x => {
                  arr = [...arr, ...x.Standard];
                });
                arr = arr.sort((a, b) => a.SetName.localeCompare(b.SetName));
                return { CheckSheetName: check.check_sheet_title, TemplateName: check.TemplateName, Drawing: check.Drawing, Samples: arr }
              } else {
                const arr = Array(check.NumOfSamples).fill().map(() => (
                  {
                    SetName: "", // Include SetName inside each Standard object
                    Standard: check.checkpoints.map(checkpoint => ({
                      ...checkpoint,
                      SetName: ""
                    }))
                  }
                )).flat() // Flatten the array so all standards are in one list

                return { CheckSheetName: check.check_sheet_title, TemplateName: check.TemplateName, Drawing: check.Drawing, Samples: arr }
              }

            })
            setQualityData(setEnableCheckSheet);
          } else {
            const mapData = checkSheet.checkSheetTitle.map(check => { return { CheckSheetName: check.check_sheet_title, TemplateName: check.TemplateName, Drawing: check.Drawing, Samples: [{ Standard: check.checkpoints }] } })
            setQualityData(mapData)
          }

          // setFinalResult([{ Standard: checkSheet.checkSheetTitle.checkpoints }])
        }

        setNumberOfSample(checkSheet.checkSheetTitle.reduce((total, x) => total + x.NumOfSamples, 0))
        setNumberOfSet(checkSheet.NumberOfSet || 0)

      }
    }
  }





  const handleImageChange = ({ file }, index, parentIdx) => {
    let file1 = [...files]
    if (!file1[parentIdx]) {
      file1[parentIdx] = [];
    }
    file1[parentIdx][index] = file;
    setFiles(file1)
    // setImageURL(doArray);
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('You can only upload image files!');
      return;
    }

    const isLt13M = file.size / 1024 / 1024 < 13;
    if (!isLt13M) {
      message.error('Image must be smaller than 13MB!');
      return;
    }

    const reader = new FileReader();
    const doArray = [...imageURL];

    reader.onload = e => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const max_width = 800; // max width to resize
        const max_height = 800; // max height to resize
        let width = img.width;
        let height = img.height;

        // Maintain aspect ratio
        if (width > height) {
          if (width > max_width) {
            height = Math.round((height *= max_width / width));
            width = max_width;
          }
        } else {
          if (height > max_height) {
            width = Math.round((width *= max_height / height));
            height = max_height;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Compress the image and get the data URL
        const dataUrl = canvas.toDataURL('image/jpeg', 0.8); // 0.8 is the quality from 0 to 1
        if (!doArray[parentIdx]) {
          doArray[parentIdx] = [];
        }

        // Assign the value to the specified index
        doArray[parentIdx][index] = { visible: true, image: dataUrl };

        setImageURL(doArray);
      };
    };

    reader.readAsDataURL(file);
  };

  console.log(imageURL, "icbkjasdcn")

  const handleModalOpen = (index, parentIdx) => {
    setModalImage(imageURL[parentIdx][index].image)
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };
  // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));



  // useEffect(() => {
  //   axios.get(api.api + `ConfigReport
  //   `
  //     // /${ChecksheetType}
  //   )
  //     .then((result) => {
  //       const data = result.data.filter((item) => item.ReportType === ChecksheetType)
  //       console.log(result.data, "cececec", data, ChecksheetType)
  //       setList(data.length > 0 ? data[0].CustomFields : []);
  //     })
  //     .catch((err) => {
  //       swal(`${err}`)

  //     })
  // }, [])

  const handleOnChange = (name, value, index) => {

    setInputData(prev => {
      const newData = { ...prev };
      // const findIdx = newData.CustomFields.findIndex(x => x.FieldName === name);
      // if (findIdx === -1) return newData  // If the field is not found, return the original data
      // Ensure CustomFields is initialized as an array
      if (!newData.CustomFields) {
        newData.CustomFields = [];
      }

      // Ensure the specific index is initialized as an object
      if (!newData.CustomFields[index]) {
        newData.CustomFields[index] = {};
      }


      if (newData.CustomFields && newData.CustomFields[index] && newData.CustomFields[index]['FieldName'] && newData.CustomFields[index]['FieldName'] !== name) {
        const findIdx = newData.CustomFields.findIndex(x => x.FieldName === name);
        newData.CustomFields[findIdx]['FieldName'] = name;
        newData.CustomFields[findIdx]['Value'] = value;
      } else {
        newData.CustomFields[index]['FieldName'] = name;
        newData.CustomFields[index]['Value'] = value;
      }

      if (errors[name]) {
        const err = { ...errors }
        delete err[name]
        setErrors(err)
      }


      return newData;
    });
  };







  // const handleGetData = async () => {
  //     // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
  //     setLoader(true)
  //     axios.put(api.api + 'partMaster', inputData)
  //         .then((result) => {
  //             setLoader(false)
  //             setQualityData(result.data);
  //             console.log(result.data, "-----------------");
  //         })
  //         .catch((err) => {
  //             setLoader(false)
  //             console.log(err);
  //         })
  // }





  const validateCustomFields = (data) => {
    const error = {};
    const errMsg = "Required fields cannot be left blank: ";
    const fieldsArr = config.CustomFields.filter(x => x.DataType !== "time_based_input")
    fieldsArr.forEach(field => {
      if (field && field?.Compulsory) {
        if (data.customFields) {
          const configField = data.customFields.find(x => x && x.FieldName === field.FieldName);
          if (configField) {
            const isListType = field.DataType === "list";
            const isEmptyList = isListType && (!configField.Value || configField.Value.length === 0);
            const isEmptyValue = !isListType && !configField.Value;
            if (isEmptyList) {
              error[configField.FieldName] = errMsg;
            } else if (isEmptyValue) {
              error[configField.FieldName] = errMsg;
            }
          } else {
            if (field.DataType == 'list') {
              error[field.FieldName] = errMsg;
            } else {
              error[field.FieldName] = errMsg;
            }
          }
        } else {
          if (field.DataType == 'list') {
            error[field.FieldName] = errMsg;
          } else {
            error[field.FieldName] = errMsg;
          }
        }

      }
    });

    return Object.keys(error).length ? error : null;
  };

  const validateCheckSheetComplete = (obj) => {

    let isError = false;
    if (obj.sampleRef.length == 0) isError = true;
    for (let i = 0; i < obj.sampleRef.length; i++) {
      for (let check of obj.Checksheet) {
        const userInputFields = getColumnsAll(selectedInspection.checkSheetTitle.find(x => x.check_sheet_title == check.CheckSheetName)?.TemplateName).filter(x => x.DataType == "UserInputDecision");
        for (let field of userInputFields) {
          if (check.StandardType == "Dimension" && check.Data[i] && !check.Data[i][field.DbFieldName]) {
            isError = true;
            break; // Exit inner loop if error is found
          }
        }
        if (isError) break; // Exit middle loop if error is found
      }
      if (isError) break; // Exit outer loop if error is found
    }

    return isError;
  };

  const handleProcess = (formData1) => {
    const showRemarkPrompt = () => {
      swal({
        title: "Are you sure?",
        text: "Number of samples inspected is less than the recommended number as specified in Standard. Please mention the reason for the non-compliance.",
        icon: "warning",
        content: {
          element: "input",
          attributes: {
            placeholder: "Enter your remarks here...",
            type: "text",
            id: "remarks-input", // Adding an id to target the input later
          },
        },
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: "Proceed",
            closeModal: false, // Keep the modal open until validation
          },
        },
      }).then((remarks) => {
        if (remarks === null) {
          // User clicked 'Cancel', simply close the modal and do nothing
          swal.close();
          return;
        }

        // If 'Proceed' clicked but no remarks provided, show an error
        if (!remarks) {
          swal({
            title: "Remarks Required!",
            text: "Please enter a reason for the non-compliance before proceeding.",
            icon: "error",
          });
          return;
        }

        // Process with the entered remarks
        console.log('Processing with remarks:', remarks);
        formData1.append("Remarks", remarks);
        handleSave(formData1);

        // Close the modal manually after processing
        swal.close();
      }).catch((error) => {
        console.log('Process canceled or error:', error);
      });
    };


    showRemarkPrompt(); // Initial call to show the remark prompt
  };


  const handleInputChange = (parentIdx, index, e, checkSheetIdx) => {
    const data = [...qualityData];
    const { name, value, label, setName } = e.currentTarget;
    if (index == "SampleName") {
      const newState = [...FinalResult];
      if (newState[checkSheetIdx][parentIdx]) {
        newState[checkSheetIdx][parentIdx]['Sample'] = e.currentTarget.value;
        newState[checkSheetIdx][parentIdx]['SetName'] = setName;
      } else {
        newState[checkSheetIdx][parentIdx] = { Sample: e.currentTarget.value, Value: '', SetName: setName };
      }

      setFinalResult(newState);
    } else {
      const cloneObj = cloneDeep(data[checkSheetIdx].Samples[parentIdx])
      cloneObj.Standard[index][name] = value;
      data[checkSheetIdx].Samples[parentIdx] = cloneObj
      if (Enable) {

        data[checkSheetIdx].Samples[parentIdx].Standard[index]["SetName"] = setName;
      }
      data[checkSheetIdx].Samples[parentIdx].Standard[index][name] = value;
      if (name == "Result") {
        data[checkSheetIdx].Samples[parentIdx].Standard[index]["ResultLabel"] = label;
      }
      setQualityData(data)

      // Ensure proper comparison, trimming whitespaces and handling case sensitivity
      const allOK = data[checkSheetIdx].Samples[parentIdx].Standard.every(item => item.Result.trim().toUpperCase() === 'OK');
      const allNA = data[checkSheetIdx].Samples[parentIdx].Standard.every(item => item.Result.trim().toUpperCase() === 'NA');
      const someNAsomeOK = data[checkSheetIdx].Samples[parentIdx].Standard.every(item => item.Result.trim().toUpperCase() === 'OK' || item.Result.trim().toUpperCase() === 'NA');
      const hasNG = data[checkSheetIdx].Samples[parentIdx].Standard.some(item => item.Result.trim().toUpperCase() === 'NG');

      console.log(data, "current target value", allOK, hasNG, 'test');

      if (allOK || (someNAsomeOK && !allNA)) {
        setFinalResult(prev => {
          const newState = [...prev];
          if (newState[checkSheetIdx][parentIdx]) {
            newState[checkSheetIdx][parentIdx]['Value'] = "OK";
            newState[checkSheetIdx][parentIdx]['SetName'] = setName;
          } else {
            newState[checkSheetIdx][parentIdx] = { Sample: "", Value: 'OK', SetName: setName };
          }
          return newState;
        });
        return "OK";
      } else if (hasNG || allNA) {
        setFinalResult(prev => {
          const newState = [...prev];
          if (newState[checkSheetIdx][parentIdx]) {
            newState[checkSheetIdx][parentIdx]['Value'] = "NG";
            newState[checkSheetIdx][parentIdx]['SetName'] = setName;
          } else {
            newState[checkSheetIdx][parentIdx] = { Sample: "", Value: 'NG', SetName: setName };
          }
          return newState;
        });
        return "NG";
      } else {
        setQualityData([...qualityData]); // Only update qualityData if no other condition is met
        return null;
      }
    }


  };
  const handleProcessWarnNG = (formData1) => {
    const showRemarkPrompt = () => {
      swal({
        title: "Are you sure?",
        text: "You want to submit NG Result for this inspection.",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: "Proceed",
            closeModal: false, // Keep the modal open until we validate the action
          },
        },
      }).then((proceed) => {
        // 'proceed' will be true only if the "Proceed" button is clicked
        if (proceed) {
          // Trigger the handleSave function only if the user confirms
          handleSave(formData1);

          // After processing, close the modal manually
          swal.close();
        }
      }).catch((error) => {
        console.log('Process canceled or error:', error);

        // Reset the button text to "Proceed" if any error occurs
        document.querySelector('.swal-button--confirm').innerText = "Proceed";
      });
    };
    showRemarkPrompt(); // Initial call to show the remark prompt
  };

  const handleOnChangeCTQ = (parentIdx, index, e, checkSheetIdx) => {
    const data = [...qualityData];
    const { name, value, label, setName } = e.currentTarget;
    data[checkSheetIdx].Samples[parentIdx].Standard[index][name] = value;
    setQualityData(data)
  }


  const validateRefrenceCode = () => {
    let refrences = [...specimenRefCode];
    refrences = refrences.filter(x => x)
    let returnResult = true;
    const checkSheet = item && item.Inspection && item.Inspection.find(x => x.InspectionName == ChecksheetType)
    if (checkSheet && checkSheet.RefSpecimen) {
      if (checkSheet.CodeRelation == "OR") {
        if (refrences.length == 0) {
          returnResult = false
          swal("Please enter a reference code. This field is mandatory.", { dangerMode: true })
        } else {
          returnResult = checkSheet.RefrenceCode.some(x => refrences.includes(x))
          if (!returnResult) {
            swal("Please enter the valid refrence code.", { dangerMode: true })
          }
        }
      } else {
        if (checkSheet.RefrenceCode && (refrences.length !== checkSheet.RefrenceCode.length)) {
          returnResult = false
          swal("Please enter a all reference code. This fields is mandatory.", { dangerMode: true })
        } else {
          returnResult = checkSheet.RefrenceCode.every(x => refrences.includes(x))
          if (!returnResult) {
            swal("Please enter the valid refrence code.", { dangerMode: true })
          }
        }
      }
    } else {
      returnResult = true
    }
    return returnResult
  }


  const validateHighSpeedCharacter = () => {
    let returnResult = true;
    const highSpeedField = inputData.CustomFields.find(x => x.DataType == "high_speed_string")
    if (highSpeedField && highSpeedField.Value && highSpeedField.Value.length !== 27) {
      returnResult = false;
      swal("Please scan a valid sample ID code with exactly 27 characters. This field is mandatory.", { dangerMode: true })
    } else {
      returnResult = true
    }
    return returnResult
  }

  const handleOnSubmit = (state) => {
    if ((state !== "Preparing") && !validateRefrenceCode()) return

    if ((state !== "Preparing") && !validateHighSpeedCharacter()) return


    const data = [...qualityData];
    const finalResult = [];
    FinalResult.forEach((arr, checkIdx) => {
      arr.forEach((sample, samIdx) => {
        if (config.SampleSerial == "Manual") {
          finalResult.push({ Sample: sample.Sample, Value: sample.Value, SetName: sample.SetName, CheckSheetName: sample.CheckSheetName })
        } else {
          if (selectedInspection.EnableSet) {
            finalResult.push({
              IsNA: notApplicableState[`NA_${sample.SetName}_${samIdx + 1}`],
              IsNARemarks: remarksState[`NA_${sample.SetName}_${samIdx + 1}`],
              CheckSheetName: sample.CheckSheetName, Sample: 'Sample' + (config.SampleSerialUnique == "Yes" ? (sampleStartIndex + (checkIdx * selectedInspection.checkSheetTitle[checkIdx].NumOfSamples * (selectedInspection.NumberOfSet || 1)) + samIdx + 1) : "1"), Value: sample.Value, SetName: sample.SetName
            })
          } else {
            finalResult.push({ CheckSheetName: sample.CheckSheetName, Sample: 'Sample' + (config.SampleSerialUnique == "Yes" ? (sampleStartIndex + (checkIdx * selectedInspection.checkSheetTitle[checkIdx].NumOfSamples * (selectedInspection.NumberOfSet || 1)) + samIdx + 1) : "1"), Value: sample.Value, SetName: sample.SetName })

          }
        }
      })
    })
    const obj = {
      RefSpecimenInput: specimenRefCode.filter(x => x),
      ApprovalReq: config.ApprovalReq, ApprovedBy: config.ApprovalRoles.map(x => { return { Role: x, Approved: false } }),
      Item: item.ItemName, ItemNumber: item.ItemNumber, Operation: item.Operation, Instrument: inputData.Instrument, InspectionType: ChecksheetType, DateTime: inputData.DateTime ? inputData.DateTime : new Date(), Checksheet: [], customFields: [...inputData.CustomFields.filter(x => x.DataType !== 'time_based_input'), ...constantFields.map(x => { return { FieldName: x.FieldName, Value: x.Value } })],
      //QtyToInspect: (selectedInspection && selectedInspection.EnableSet ? NumberOfSample * (selectedInspection.NumberOfSet || 0) : NumberOfSample),
      QtyToInspect: selectedInspection?.checkSheetTitle?.reduce((total, x) => total + (selectedInspection.EnableSet && x.SetApplicable ? x.NumOfSamples * (selectedInspection.NumberOfSet || 1) : x.NumOfSamples), 0),
      OkParts: (finalResult.filter(one => one && one.Value === 'OK')).length,
      QtyInspected: finalResult.length,
      sampleRef: finalResult
    }


    data.forEach((checkSheet, checkIdx) => {
      const constantColumn = getColumnsAll(checkSheet.TemplateName).filter(x => !x.DataType.startsWith('UserInput'))
      const userInput = getColumnsAll(checkSheet.TemplateName).filter(x => x.DataType.startsWith('UserInput'))
      data[checkIdx].Samples[0].Standard.forEach((parameter, idx) => {
        const report = { Data: [], CheckSheetName: checkSheet.CheckSheetName };
        constantColumn.forEach((constant) => report[constant.DbFieldName] = parameter[constant.DbFieldName])
        report["StandardType"] = parameter.StandardType
        data[checkIdx].Samples.forEach(item => {
          const matchingItem = item.Standard.filter((items, index) => idx === index);
          const dataObj = { Result: matchingItem[0].Result, ResultLabel: matchingItem[0].ResultLabel, SetName: matchingItem[0].SetName || "-" }
          userInput.forEach((input) => dataObj[input.DbFieldName] = matchingItem[0][input.DbFieldName])
          report.Data.push(dataObj);
        });
        obj.Checksheet.push(report);
      });
    })
    const error = validateCustomFields(obj);
    if (error && (state !== "Preparing")) {
      //setErrors(error)
      const keys = Object.keys(error);
      const error1 = "Required fields cannot be left blank: " + keys.join(', ');
      swal('ERROR', error1, { dangerMode: true })
      return
    }

    const err = validateCheckSheetComplete(obj)
    if (err && (state !== "Preparing")) {
      let userInputFields = [];
      selectedInspection.checkSheetTitle.forEach((check) => {
        userInputFields = [...userInputFields, ...getColumnsAll(check?.TemplateName).filter(x => x.DataType.startsWith('UserInputDecision'))];
      })
      swal('ERROR', "Check Points cannot be left blank. Please input for checkpoints: " + userInputFields.map(x => x.FieldName).join(', '), { dangerMode: true })
      return
    }
    obj.Files = files;
    obj.State = state;
    const formData1 = new FormData();
    formData1.append('Data', JSON.stringify(obj));

    Array.from(files).forEach(file => {
      formData1.append('files', file);
    });
    Array.from(imageURL).forEach(file => {
      formData1.append('files', file);
    });
    if ((addMoreCount < NumberOfSample) && (config.ContinousDataEntry == "disable") && (state !== "Preparing") && (!selectedInspection.EnableSet)) {
      handleProcess(formData1)
    } else {
      if ((config.NGResultWarning == "enable") && obj.sampleRef.some(x => x.Value == "NG") && (state !== "Preparing")) {
        handleProcessWarnNG(formData1)
      } else {
        handleSave(formData1)
      }
    }
  }




  const handleSave = (formData1) => {
    if (location.state && location.state.action == "edit") {
      setLoader(true);
      axios.patch(api.api + 'checkSheetDataEntry/' + location.state.obj._id, formData1, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((result) => {
          if (config.ContinousDataEntry == "enable") {
            // setQualityData([]);
            setInputData(prevInputData => ({
              ...prevInputData,
              // DateTime: new Date(),
              Instrument: [],
            }));

            initializedData();
            initializedInputFocus();
            //setFinalResult([])
            toast.success(`Data saved. Enter the next entry.`, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: 'green', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });
            //  swal("Data saved. Enter the next entry.");
          } else {
            swal("Data Saved Successfully");
            setQualityData([]);
            history.goBack();
          }
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response && err.response.data) {
            if (err.response.data.message) {
              toast.success(`${err.response.data.message}`, {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  background: 'red', // Set your desired background color
                  color: 'white',     // Set your desired text color
                },
              });
            } else {
              toast.success(`${err.response.data}`, {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: {
                  background: 'red', // Set your desired background color
                  color: 'white',     // Set your desired text color
                },
              });
            }

          }

          console.log(err);
        });
    } else {
      setLoader(true);
      axios.post(api.api + 'checkSheetDataEntry', formData1, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((result) => {
          if (config.ContinousDataEntry == "enable") {
            // setQualityData([]);
            setInputData(prevInputData => ({
              ...prevInputData,
              // DateTime: new Date(),
              Instrument: [],
            }));

            initializedData();
            initializedInputFocus();
            //setFinalResult([])
            toast.success(`Data saved. Enter the next entry.`, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: 'green', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });
            //  swal("Data saved. Enter the next entry.");
          } else {
            swal("Data Saved Successfully");
            setQualityData([]);
            history.goBack();
          }
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response && err.response.data && err.response.data.message) {
            toast.success(`${err.response.data.message}`, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: 'red', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });
          } else {
            toast.success(`${err.response.data}`, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: 'red', // Set your desired background color
                color: 'white',     // Set your desired text color
              },
            });
          }
        });
    }
  }

  const [addMoreCount, setAddMoreCount] = useState(1); // State to keep track of the number of times addMore has been called
  const handleFinalResult = (data = []) => {
    if (!Array.isArray(data) || data.length === 0) return "NG";

    const allOK = data.every((item) => item.Result === "OK");

    return allOK ? "OK" : "NG";
  };

  const addMore = (setName, checkSheetIdx) => {
    const cloneItem = cloneDeep(itemList.find(x => x._id == item._id))
    const checkSheet = cloneItem && cloneItem.Inspection.find(x => x.InspectionName == ChecksheetType)
    if (qualityData[checkSheetIdx].Samples.length >= checkSheet.checkSheetTitle[checkSheetIdx].NumOfSamples) {
      // Optionally, you can notify the user that they cannot add more
      alert(`Cannot add more. Limit reached in this checksheet (${checkSheet.checkSheetTitle[checkSheetIdx].NumOfSamples} times).`);
      return;
    }

    const data = cloneDeep(qualityData);
    const finalResult = cloneDeep(FinalResult);
    const obj = cloneDeep(data[checkSheetIdx].Samples[data[checkSheetIdx].Samples.length - 1]);
    finalResult[checkSheetIdx].push({ Sample: '', CheckSheetName: data[checkSheetIdx].CheckSheetName, Value: handleFinalResult(obj.Standard) })
    obj.Standard.forEach((one) => {
      delete one.ObservedValue;
      one.Result = config.DefaultSelection;
      delete one.Remarks;
    });
    setFinalResult(finalResult);
    data[checkSheetIdx].Samples.push(getNewCheckSheetObj(setName, checkSheetIdx))
    setQualityData([...data]);
    setAddMoreCount(addMoreCount + 1); // Increment the count after successfully adding
  };
  const removeRow = (checkSheetIdx) => {
    let data = [...qualityData];
    const results = [...FinalResult]
    results[checkSheetIdx].splice(results[checkSheetIdx].length - 1, 1)
    data[checkSheetIdx].Samples.splice(data[checkSheetIdx].length - 1, 1)
    setFinalResult(results);
    setAddMoreCount(prev => prev - 1)
    setQualityData(data);
  }
  const handelfinalResult = (data = []) => {
    if (!Array.isArray(data) || data.length === 0) return undefined;

    const allOK = data.every((item) => item.Result === "OK");
    const allNA = data.every((item) => item.Result === "NA");
    const allNG = data.every((item) => item.Result === "NG");
    const onlyOKorNA = data.every((item) => item.Result === "OK" || item.Result === "NA");
    const hasNG = data.some((item) => item.Result === "NG");

    console.log({ allOK, onlyOKorNA, allNG, allNA, hasNG });

    if (allNG || hasNG || allNA) {
      return "NG";
    }

    else if (allOK || (onlyOKorNA && !allNA)) {
      return "OK";
    }

    return undefined;
  };


  const handelfinalAccuracy = (data = []) => {
    const onlyOKorNA = data.filter((item) => item.Result === "OK" || item.Result === "NA");
    const hasNG = data.filter((item) => item.Result === "NG");
    return `( ${onlyOKorNA.length} / ${data.length} )` || 0;
  };



  const handleOnChangeDateTime = (type, value) => {
    let newDateTime;
    if (type === 'date') {
      // Update date part, keep time part
      const currentMoment = moment(inputData.DateTime);
      newDateTime = moment(value + "T" + currentMoment.format('HH:mm')).toDate();
    } else if (type === 'time') {
      // Update time part, keep date part
      const currentMoment = moment(inputData.DateTime);
      newDateTime = moment(currentMoment.format('YYYY-MM-DD') + "T" + value).toDate();
    }
    // handleOnChange("DateTime",newDateTime)
    setInputData({ ...inputData, DateTime: newDateTime });
  };



  const getDataTypeElement = (parentIdx, currentIdx, field, data, sheetLen, checkSheetIdx, templateName) => {
    const dimensionTypes = ["Dimension+Tolerance", "Dimension-Tolerance", "StandardDimension"];
    if ((data.StandardType == "Description") && dimensionTypes.includes(field.DataType)) {
      return <></>
    }
    switch (field.DataType) {
      case 'UserInputDecision':
        if (data.StandardType == "Dimension") {
          const plusCol = getColumnsAll(templateName).find(x => x.DataType == "Dimension+Tolerance");
          const minusCol = getColumnsAll(templateName).find(x => x.DataType == "Dimension-Tolerance");
          const standardNum = getColumnsAll(templateName).find(x => x.DataType == "StandardDimension");
          return (
            <div >
              <input
                onBlur={() => {
                  let observedValue = field.DbFieldName && parseFloat(data[field.DbFieldName]);
                  let plusValue = plusCol.DbFieldName && parseFloat(data[plusCol.DbFieldName]);
                  let minusValue = minusCol.DbFieldName && parseFloat(data[minusCol.DbFieldName]);
                  let standardValue = standardNum && standardNum.DbFieldName && parseFloat(data[standardNum.DbFieldName]);

                  const plus = standardValue + plusValue;
                  const minus = standardValue - minusValue;

                  // Clone qualityData to avoid mutating the state directly
                  const data1 = [...qualityData];

                  // Perform the check and update the result
                  if (!data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx][field.DbFieldName]) {
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["Result"] = "NG";
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["ResultLabel"] = "NG";
                  }

                  else if (data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx][field.DbFieldName] == "-") {
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["Result"] = "NA";
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["ResultLabel"] = "NA";
                  }

                  else if (minus <= observedValue && observedValue <= plus) {
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["Result"] = "OK";
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["ResultLabel"] = "OK";
                  } else {
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["Result"] = "NG";
                    data1[checkSheetIdx].Samples[parentIdx].Standard[currentIdx]["ResultLabel"] = "NG";
                  }

                  // Update qualityData after processing
                  setQualityData(data1);

                  // Now call handleInputChange to ensure it runs in sync
                  handleInputChange(parentIdx, currentIdx, { currentTarget: { name: field.DbFieldName, value: data[field.DbFieldName], setName: data['SetName'] } }, checkSheetIdx);
                }}
                pattern="^-?[0-9]*\.?[0-9]*$"
                type="text"
                className="form-control form-control-sm p-0 text-center"
                id={field.DbFieldName}
                name={field.DbFieldName}
                placeholder={field.placeholder || ''}
                ref={(el) => (inputRefs.current[`${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`] = el)}  // Store ref for each input
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const keys = Object.keys(inputRefs.current)
                    const currentIdx1 = keys.findIndex(x => x == `${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`);
                    const nexKey = keys[currentIdx1 + 1]
                    handleFocusNext(nexKey);
                    // const isLastField = currentIdx === sheetLen - 1;

                    // if (isLastField && config.SampleSerial == "Manual") {
                    //   e.key === 'Enter' && handleFocusNext(`${checkSheetIdx}-${parentIdx + 1}` + `Parent`)
                    // }
                    // else if (isLastField) {
                    //   // Move focus to the first input of the next section (e.g., `1-0`)
                    //   const nextSectionKey = `${parentIdx + 1}-${checkSheetIdx}-0`;
                    //   handleFocusNext(nextSectionKey);  // Focus on the first input of the next section
                    // }
                    // else {
                    //   const nextFieldKey = `${checkSheetIdx}-${parentIdx}-${currentIdx + 1}`;
                    //   handleFocusNext(nextFieldKey);
                    // }
                  }
                }}
                onChange={(e) => handleInputChange(parentIdx, currentIdx, {
                  currentTarget: {
                    name: e.target.name,
                    value: e.target.value,
                    setName: data['SetName']
                  }
                }, checkSheetIdx)}
                value={data[field.DbFieldName] || ""}
              />


            </div>
          );
        }
        else if (data.StandardType == "Description") {
          return (
            <div className='text-center d-flex '>
              {config.ResultConfigure && config.ResultConfigure.map((x, index) => {
                return <label
                  style={{ fontSize: 20, fontWeight: 'bold' }}
                  key={index}
                  className={`${index > 0 ? 'ml-3' : ''} ${focusedInput === `${checkSheetIdx}-${parentIdx}-${currentIdx}` ? 'label-focused shadow' : ''}`} // Highlight label when focused
                >
                  <input
                    style={{ width: 22, height: 22 }}
                    className={`mt-1 ${focusedInput === `${checkSheetIdx}-${parentIdx}-${currentIdx}` ? 'radio-focused' : ''}`} // Highlight radio button

                    type="radio"
                    name={field.DbFieldName + checkSheetIdx + parentIdx + currentIdx}
                    value="OK"
                    checked={data.Result === x.TreatAs}
                    ref={(el) => (inputRefs.current[`${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`] = el)} // Store ref for each input
                    onFocus={() => setFocusedInput(`${checkSheetIdx}-${parentIdx}-${currentIdx}`)} // Set focused input
                    onBlur={() => setFocusedInput(null)} // Remove highlight on blur
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const keys = Object.keys(inputRefs.current)
                        const currentIdx1 = keys.findIndex(x => x == `${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`);
                        const nexKey = keys[currentIdx1 + 1];
                        handleFocusNext(nexKey);
                        // const isLastField = currentIdx === sheetLen - 1;

                        // if (isLastField && config.SampleSerial == 'Manual') {
                        //   handleFocusNext(`${checkSheetIdx}${parentIdx + 1}` + `Parent`);
                        // } else if (isLastField) {
                        //   const nextSectionKey = `${parentIdx + 1}-${checkSheetIdx}-0`;
                        //   handleFocusNext(nextSectionKey); // Focus on the first input of the next section
                        // } else {
                        //   const nextFieldKey = `${checkSheetIdx}-${parentIdx}-${currentIdx + 1}`;
                        //   handleFocusNext(nextFieldKey);
                        // }
                      }
                    }}
                    onChange={(e) => {

                      handleInputChange(parentIdx, currentIdx, {
                        currentTarget: {
                          name: "Result",
                          value: x.TreatAs,
                          label: x.Result,
                          setName: data.SetName
                        },
                      },
                        checkSheetIdx
                      )
                    }



                    }
                  />
                  &nbsp;{x.Result}
                </label>
              })}

            </div>
          );
        }
        else { return 'NA' }
      case 'UserInputNumber':
        return (
          <div >
            <input
              type="number"
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || ''}
              onChange={(e) => handleInputChange(parentIdx, currentIdx, { currentTarget: { name: e.currentTarget.name, value: e.currentTarget.value, label: e.currentTarget.label, setName: data.SetName } }, checkSheetIdx)}
              value={data[field.DbFieldName] || ""}
              ref={(el) => (inputRefs.current[`${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`] = el)}  // Store ref for each input
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const keys = Object.keys(inputRefs.current)
                  const currentIdx1 = keys.findIndex(x => x == `${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`);
                  const nexKey = keys[currentIdx1 + 1];
                  handleFocusNext(nexKey);
                  // const isLastField = currentIdx === sheetLen - 1;

                  // if (isLastField && config.SampleSerial == "Manual") {
                  //   e.key === 'Enter' && handleFocusNext(`${checkSheetIdx}${parentIdx + 1}` + `Parent`)
                  // }
                  // else if (isLastField) {
                  //   // Move focus to the first input of the next section (e.g., `1-0`)
                  //   const nextSectionKey = `${parentIdx + 1}-${checkSheetIdx}-0`;

                  //   handleFocusNext(nextSectionKey);  // Focus on the first input of the next section
                  // } else {
                  //   const nextFieldKey = `${checkSheetIdx}-${parentIdx}-${currentIdx + 1}`;
                  //   handleFocusNext(nextFieldKey);
                  // }
                }
              }}
            // onKeyDown={(e) => {
            //   if (e.key === 'Enter') {
            //     const nextFieldKey = `${parentIdx}-${currentIdx + 1}`;
            //     handleFocusNext(nextFieldKey);  // Focus on the next input field
            //   }
            // }}
            />
          </div>
        );
      case 'UserInputString':
        return (
          <div >
            <input
              type="text"
              className="form-control form-control-sm p-0"
              id={field.DbFieldName}
              name={field.DbFieldName}
              value={data[field.DbFieldName] || ""}
              placeholder={field.placeholder || ''}
              ref={(el) => (inputRefs.current[`${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`] = el)}  // Store ref for each input
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const keys = Object.keys(inputRefs.current)
                  const currentIdx1 = keys.findIndex(x => x == `${checkSheetIdx}-${parentIdx}-${currentIdx}-${field.DbFieldName}`);
                  const nexKey = keys[currentIdx1 + 1];
                  handleFocusNext(nexKey);
                  // const isLastField = currentIdx === sheetLen - 1;

                  // if (isLastField && config.SampleSerial == "Manual") {
                  //   e.key === 'Enter' && handleFocusNext(`${checkSheetIdx}${parentIdx + 1}` + `Parent`)
                  // }
                  // else if (isLastField) {
                  //   // Move focus to the first input of the next section (e.g., `1-0`)
                  //   const nextSectionKey = `${parentIdx + 1}-${checkSheetIdx}-0`;

                  //   handleFocusNext(nextSectionKey);  // Focus on the first input of the next section
                  // } else {
                  //   const nextFieldKey = `${checkSheetIdx}-${parentIdx}-${currentIdx + 1}`;
                  //   handleFocusNext(nextFieldKey);
                  // }
                }
              }}
              onChange={(e) => handleInputChange(parentIdx, currentIdx, { currentTarget: { name: e.currentTarget.name, value: e.currentTarget.value, label: e.currentTarget.label, setName: data.SetName } }, checkSheetIdx)}
            />
          </div>
        );
      case 'ConstantString':
        return (
          <div>
            <p className='custom-paragraph'>{data[field.DbFieldName] || ""}</p>

          </div>
        );
      case 'StandardDimension':
        return (
          <div >
            <input
              disabled
              type="number"
              value={data[field.DbFieldName] || ""}
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || ''}
            // onChange={handleOnChange}
            />
          </div>
        );
      case 'Dimension+Tolerance':
        return (
          <div >
            <input
              disabled
              type="number"
              value={data[field.DbFieldName] || ""}
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || '+ Tolerance'}
            // onChange={handleOnChange}
            />
          </div>
        );
      case 'Dimension-Tolerance':
        return (
          <div >
            <input
              disabled
              type="number"
              value={data[field.DbFieldName] || ""}
              className="form-control form-control-sm p-0 text-center"
              id={field.DbFieldName}
              name={field.DbFieldName}
              placeholder={field.placeholder || '- Tolerance'}
            // onChange={handleOnChange}
            />
          </div>
        );
      default:
        return <></>;
    }
  }

  const ImageUpload = (data) => {
    console.log(data, "image uploaddata");
    setImageURLData(data)
  }
  const getDeafultSelectAll = (parentIdx, field, checkSheetIdx) => {
    if (field.DataType == "UserInputDecision") {
      return (
        <div className='text-center d-flex'>
          {config.ResultConfigure && config.ResultConfigure.map((x, index) => {
            return x.IsEnableAll && <label
              style={{ fontWeight: 'bold', fontSize: 15 }}
              className={index > 0 ? "ml-3" : ""}>
              <input
                className="mt-1"
                type="radio"
                name={"All" + parentIdx}
                value="OK"
                checked={
                  qualityData?.[checkSheetIdx]?.Samples?.[parentIdx]?.Standard
                    ?.filter(res => res.StandardType === "Description")
                    ?.every(res => res.Result === x.TreatAs) || false
                }
                onChange={(e) => {
                  const data = [...qualityData];

                  // Guard clause to prevent errors
                  if (!data[checkSheetIdx]?.Samples?.[parentIdx]?.Standard) return;

                  // Update only 'Description' type results
                  data[checkSheetIdx].Samples[parentIdx].Standard.forEach((check) => {
                    if (check.StandardType === "Description") {
                      check.Result = x.TreatAs;
                    }
                  });

                  const standards = data[checkSheetIdx].Samples[parentIdx].Standard;

                  // Determine final value based on Result values
                  const hasNG = standards.some(
                    item => item.Result?.trim().toUpperCase() === "NG"
                  );
                  const allOK = standards.every(
                    item => item.Result?.trim().toUpperCase() === "OK"
                  );
                  const someOKsomeNA = standards.every(item => {
                    const result = item.Result?.trim().toUpperCase();
                    return result === "OK" || result === "NA";
                  });

                  const finalValue = hasNG ? "NG" : (allOK || someOKsomeNA ? "OK" : "");

                  setFinalResult((prev) => {
                    const newState = [...prev];
                    if (!newState[checkSheetIdx]) {
                      newState[checkSheetIdx] = [];
                    }

                    newState[checkSheetIdx][parentIdx] = {
                      Sample: "",
                      Value: finalValue,
                      setName: data[checkSheetIdx][parentIdx]?.SetName || "",
                      CheckSheetName: data[checkSheetIdx]?.CheckSheetName || ""
                    };

                    console.log("Updated finalResult:", newState);
                    console.log("Updated qualityData:", data);
                    return newState;
                  });

                  setQualityData(data);
                }}
              />


              &nbsp;All {x.Result}
            </label>
          })}

        </div>
      );
      return <></>
    }
    return <></>
  }

  const getListNames = () => {
    axios.get(api.api + 'ListMaster')
      .then((result) => {
        // consol(result.data)
        setLoader(false)
        setList(result.data);
      })
      .catch((err) => {
        swal(`${err}`)
        setLoader(false)
      })
  }


  const getListValues = (item1) => {
    const itemMaster = item?.Inspection?.find(x => x.InspectionName === ChecksheetType);
    const field = itemMaster?.CustomFields?.find(x => x.FieldName == item1.FieldName)
    if (item1.DataType === 'time_based_input') {
      const filteredlist = RuleData.filter(rule => rule.RuleName === field.ListName)
      if (filteredlist.length > 0) {
        const list = filteredlist[0].Rules.map(rule => { return { label: rule.Tag, value: rule.Tag } })
        return { options: list, isMulti: field.EnableMultiSelect };

      } else {

        return { options: [], isMulti: false };
      }


    } else {
      if (!field) return [];

      const listItem = List.find(listItem => listItem.ListName == field.ListName);

      if (!listItem) return [];

      return { options: listItem.contents.map(content => { return { label: content, value: content } }), isMulti: field.EnableMultiSelect };
    }

  };


  const getCarryValue = (field, defaultValue) => {
    const fields = [...inputData.CustomFields];
    const value = fields.find(x => field && x && x.FieldName == field.FieldName);
    if (value && value.Value) {
      return value.Value
    }
    return defaultValue
  }

  const getRefrenceSpecimen = () => {
    const checkSheet = item && item.Inspection && item.Inspection.find(x => x.InspectionName == ChecksheetType)
    if (checkSheet && checkSheet.RefSpecimen && checkSheet.RefrenceCode.length > 0) {
      if (checkSheet.CodeRelation == "OR" && checkSheet.RefrenceCode.length > 0) {
        checkSheet.RefrenceCode = [checkSheet.RefrenceCode[0]]
      }
      return <>
        <div className='col-sm-12 mt-4 text-center'>
          <div style={{ height: 18 }} className='row text-left ml-1'>
            <label className="fs-8 fw-bolder">
              Enter Reference Specimen
              <span className='text-danger'>*</span>
            </label>
          </div>
          <div className='row  ml-3'>
            {checkSheet.RefrenceCode && checkSheet.RefrenceCode.map((code, idx) => {
              return checkSheet.InputType == "ScannerInput" ?
                <HighSpeedDataType
                  config={config}
                  inputRefs={inputRefs}
                  field={{ FieldName: `Refrence Code` }}
                  value={specimenRefCode[idx] || ""}
                  getString={(string) => {
                    const values = [...specimenRefCode];
                    if (string) {
                      if (values[idx]) {
                        values[idx] = string;
                      } else {
                        values.push(string);
                      }
                      setSpecimenRefCode(values);
                    }
                  }}
                />
                : <div className='col-sm-3 text-left p-0 m-0'>
                  <div className="form-group">
                    <input value={specimenRefCode[idx] || ""} onChange={(e) => {
                      const values = [...specimenRefCode];
                      if (values[idx]) {
                        values[idx] = e.currentTarget.value;
                      } else {
                        values.push(e.currentTarget.value);
                      }
                      setSpecimenRefCode(values);
                    }} placeholder={`Enter Ref Code `} className='form-control form-control-sm' type={"text"} />
                  </div>
                </div>
            })}
          </div>
        </div>
      </>
    }
    return <></>

  }

  function openBase64InNewTab(base64String, fileType = 'application/pdf') {
    // Create a new window or tab with the base64 data
    alert(base64String)
    const newTab = window.open();
    let content = '';
    // Format the base64 string as a data URL with the correct MIME type
    if (base64String.startsWith("data:image/")) {
      content = `<img src="${base64String}" style="width:100%; height:100%; border:none;" />`;
    } else {
      content = `
        <iframe 
          src=${base64String}
          style="border:none; width:100%; height:100%;" 
        ></iframe>
      `;
    }
    newTab.document.write(content);
  }

  // function openBase64InNewTab(base64String, fileType = 'application/pdf') {
  //   // Check if a new tab can be opened
  //   const newTab = window.open();
  //   if (!newTab) {
  //     alert("Unable to open a new tab. Please allow pop-ups for this site.");
  //     return;
  //   }

  //   let content = '';
  //   // Format the base64 string as a data URL with the correct MIME type
  //   if (fileType.startsWith("image/")) {
  //     // If it's an image, display it using <img>
  //     content = `<img src="${base64String}" style="width:100%; height:100%; border:none;" />`;
  //   } else if (fileType === 'application/pdf') {
  //     // If it's a PDF, format the base64 string properly
  //     content = `
  //       <iframe 
  //         src="data:${fileType};base64,${base64String}" 
  //         style="border:none; width:100%; height:100%;" 
  //       ></iframe>
  //     `;
  //   } else {
  //     // Handle other file types if needed
  //     content = `<p>Unsupported file type.</p>`;
  //   }

  //   // Write content to the new tab
  //   newTab.document.open();
  //   newTab.document.write(`
  //     <html>
  //       <head>
  //         <title>File Preview</title>
  //       </head>
  //       <body style="margin:0; overflow:hidden;">
  //         ${content}
  //       </body>
  //     </html>
  //   `);
  //   newTab.document.close();
  // }

  const getColumns = (TemplateName) => templateList.find(x => x.Name == TemplateName) ? templateList.find(x => x.Name == TemplateName).Columns.filter(x => x.EnableForDataEntry) : [];
  const getColumnsAll = (TemplateName) => templateList.find(x => x.Name == TemplateName) ? templateList.find(x => x.Name == TemplateName).Columns : [];

  const YourComponent = (samples = [], TemplateName, checkSheetIdx) => {
    // Array to track printed SetNames, move it outside map to persist across iterations
    let printedSetNames = [];

    const renderSetName = (sample) => {
      // If SetName hasn't been printed, print it and add it to the array
      if (sample.SetName && !sample.SetName.includes('-') && !printedSetNames.includes(sample.SetName)) {
        printedSetNames.push(sample.SetName);
        return (
          <h4 style={{ fontSize: 15, margin: 0 }}>Set Name - {sample.SetName}</h4>
        );
      }
      // Otherwise, return null to avoid duplicate printing
      return null;
    };

    return (
      <>
        {samples.length > 0 ? (
          <>
            {samples.map((sample, parentIdx) => (
              <React.Fragment key={parentIdx}>
                {/* Call renderSetName to conditionally print SetName */}
                {selectedInspection.EnableSet && renderSetName(sample)}
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '15px', marginTop: 15 }}>
                  <h4 style={{ fontSize: 15, marginTop: 15 }}>
                    Sample Serial :
                    {config && config.SampleSerial === "Manual" ? (
                      <input
                        ref={(el) => (inputRefs.current[`${checkSheetIdx}-${parentIdx}-Manual`] = el)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            const keys = Object.keys(inputRefs.current)
                            const currentIdx1 = keys.findIndex(x => x == `${checkSheetIdx}-${parentIdx}-Manual`);
                            const nexKey = keys[currentIdx1 + 1];
                            handleFocusNext(nexKey);
                          }
                        }}
                        onChange={(e) => handleInputChange(parentIdx, 'SampleName', e, checkSheetIdx)}
                        placeholder='enter manual sample..'
                        style={{ width: '30%' }}
                        type='text'
                        className='form-control form-control-sm'
                      />
                    ) : (
                      '#' + (config.SampleSerialUnique === "Yes"
                        ? sampleStartIndex + parentIdx + 1
                        : parentIdx + 1)
                    )}
                  </h4>
                  {selectedInspection.EnableSet && <>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: 14 }}>
                      <input
                        type="checkbox"
                        name={`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`}
                        checked={notApplicableState[`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`]}
                        onChange={(e) => {
                          const obj = { ...notApplicableState };
                          obj[`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`] = e.currentTarget.checked;
                          setNotApplicableState(obj);
                          if (!e.currentTarget.checked) {
                            const remarksObj = { ...remarksState };
                            remarksObj[`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`] = '';
                            setRemarksState(remarksObj);
                          }
                        }}

                      />
                      Not Applicable <p className="small mt-2">(if enabled, please provide remarks.)</p>
                    </label>
                    {notApplicableState[`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`] && (
                      <input
                        className='form-control form-control-sm'
                        type="text"
                        placeholder="Enter Remarks"
                        value={remarksState[`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`] || ''}
                        onChange={(e) => {
                          const remarksObj = { ...remarksState };
                          remarksObj[`NA_${sample.SetName}_${sampleStartIndex + parentIdx + 1}`] = e.currentTarget.value;
                          setRemarksState(remarksObj);
                        }}
                        style={{
                          padding: '5px 10px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          fontSize: 14,
                          maxWidth: '400px'
                        }}
                      />
                    )}
                  </>}

                </div>


                {/* Table rendering */}
                <table style={{ tableLayout: 'auto', display: 'table' }} className="small table-sm table-bordered table-responsive">
                  <thead>
                    <tr className="text-center">

                      {getColumns(TemplateName)
                        .filter((x) => x.DataType !== "Image")
                        .map((x, idx) => (
                          <th key={idx}>{x.FieldName}</th>
                        ))}
                      {sample && sample.Standard && sample.Standard.find(x => x.CTQ) ? <th key="CTQ">CTQ</th> : <></>}
                    </tr>
                  </thead>

                  <tbody>
                    {sample.Standard && sample.Standard.map((one, index) => {
                      const color = config.ResultConfigure.find(x => x.TreatAs === one.Result);
                      return (
                        <tr className='text-center' style={{ backgroundColor: color ? color.Color : "yellow", padding: 0 }} key={index}>
                          {getColumns(TemplateName)
                            .filter((x) => x.DataType !== "Image")
                            .map((x, idx) => (
                              <td key={idx}>{getDataTypeElement(parentIdx, index, x, one, sample.Standard.length, checkSheetIdx, TemplateName)}</td>
                            ))}
                          {sample.Standard && sample.Standard.find(x => x.CTQ) && one.CTQ ? <td className='d-flex text-center'>
                            <label
                              style={{ fontSize: 14, fontWeight: 'bold' }}
                              className={'label-focused'}
                            >
                              <input
                                checked={one.CTQ == "Yes"}
                                onChange={(e) => {
                                  handleOnChangeCTQ(parentIdx, index, {
                                    currentTarget: {
                                      name: "CTQ",
                                      value: "Yes",
                                      label: "Yes"
                                    },
                                  },
                                    checkSheetIdx
                                  )
                                }}
                                style={{ width: 18, height: 22 }}
                                type="radio"
                                name={"CTQ" + parentIdx + index + checkSheetIdx}
                              />
                              &nbsp; &nbsp;
                              Yes
                            </label>
                            <label
                              style={{ fontSize: 14, fontWeight: 'bold' }}
                              className={'label-focused'}
                            >
                              <input
                                checked={one.CTQ == "No"}
                                onChange={(e) => {
                                  handleOnChangeCTQ(parentIdx, index, {
                                    currentTarget: {
                                      name: "CTQ",
                                      value: "No",
                                      label: "No"
                                    },
                                  },
                                    checkSheetIdx
                                  )
                                }}
                                style={{ width: 18, height: 22 }}
                                type="radio"
                                name={"CTQ" + parentIdx + index + checkSheetIdx}
                              />
                              &nbsp; &nbsp;
                              No
                            </label>
                          </td>
                            :
                            sample.Standard.find(x => x.CTQ) && <td>

                            </td>
                          }
                        </tr>
                      );
                    })}
                    <tr className='text-center' style={{ backgroundColor: "lightgray", padding: 0 }} key="All">
                      {getColumns(TemplateName)
                        .filter((x) => x.DataType !== "Image")
                        .map((x, idx) => (
                          <td key={idx}>{getDeafultSelectAll(parentIdx, x, checkSheetIdx)}</td>
                        ))}
                    </tr>
                  </tbody>
                </table>

                <div className='text-center'>
                  {sample.Standard && sample.Standard.length > 0 &&
                    config.ShowAccuracyResult == "Yes" ? (
                    <div className='p-2 text-black fw-bold' style={{ backgroundColor: `skyblue` }}>
                      Accuracy : {handelfinalAccuracy(sample.Standard)}
                    </div>
                  ) : (
                    <div className='p-2 text-white fw-bold' style={{ backgroundColor: `${handelfinalResult(sample.Standard) === 'OK' ? 'green' : 'red'}` }}>
                      Result : {handelfinalResult(sample.Standard)}
                    </div>
                  )}
                </div>
              </React.Fragment>
            ))}

            {/* Buttons for adding/removing rows */}
            <div className='d-flex float-end'>
              <div>
                {samples.length > 1 && !Enable && (
                  <span className="mt-2 mr-4 float-right" style={{ cursor: 'pointer' }} onClick={() => removeRow(checkSheetIdx)}>
                    <FontAwesomeIcon size='2x' icon={faMinusCircle} />
                  </span>
                )}
                {config.ContinousDataEntry === "disable" && !Enable && (
                  <span className="mt-2 mr-4 float-right" style={{ cursor: 'pointer' }} onClick={() => addMore("", checkSheetIdx)}>
                    <FontAwesomeIcon size='2x' icon={faPlusCircle} />
                  </span>
                )}
              </div>
              {/* <div className='mx-1 d-flex align-items-center fw-bolder mt-1'>
                <button className='btn-sm btn-primary' onClick={() => {
                  if (config.ApprovalReq == "No") {
                    handleOnSubmit("Closed")
                  } else {
                    if (location.state.obj && location.state.obj.State == "Closed") {
                      handleOnSubmit("Closed")
                    } else {
                      handleOnSubmit("PendingApproval")
                    }
                  }
                }}>Submit</button>
              </div> */}
            </div>
          </>
        ) : (
          <p className="mt-5 small text-center">No Data</p>
        )}
      </>
    );
  };


  const AccordianComp = (drawing, name = "", TemplateName, id, samples = []) => {
    const panelId = `panel-${id}`; // Unique ID for the panel
    const headerId = `header-${id}`; // Unique ID for the header
    return (
      <div className="accordion-item border-0">
        <h2 style={{ width: '99%', padding: '12px' }} className="accordion-header" id={headerId}>
          <button
            style={{
              "border": "solid 1px lightgray",
              borderRadius: 10
            }}
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${panelId}`} // Target the unique panel ID
            aria-expanded="false"
            aria-controls={panelId}
          >
            {name}
          </button>
        </h2>
        <div
          style={{ paddingBottom: '34px' }}
          id={panelId}
          className="accordion-collapse collapse show"
          aria-labelledby={headerId}
          data-bs-parent="#accordionParent" // Ensures only one is open at a time
        >
          <div className="accordion-body">
            {drawing && <img width={'100%'} height={600} src={drawing} title='drawing' />}
            {YourComponent(samples, TemplateName, id)}
          </div>
        </div>
      </div>
    );
  };

  const IsSetApplicable = (sheetName) => {
    if (selectedInspection && selectedInspection.EnableSet) {
      const sheet = selectedInspection.checkSheetTitle.find(x => x.check_sheet_title == sheetName);
      if (sheet && sheet.SetApplicable) {
        return true;
      }
      return false
    }
    return false
  }

  const totalSampleWhenSetEnable = () => {
    let total = 0;
    if (selectedInspection && selectedInspection.EnableSet) {
      selectedInspection.checkSheetTitle.forEach(x => {
        if (x && x.SetApplicable) {
          total = total + (x.NumOfSamples * NumberOfSet)
        } else {
          total = total + x.NumOfSamples
        }
      })
    }
    return total;
  }


  const finalAccuarcy = () => {
    const total = qualityData?.reduce(
      (sum, x) => sum + x.Samples?.reduce((s, one) => s + (one.Standard?.length || 0), 0),
      0
    ) || 0;

    const passed = qualityData?.reduce(
      (sum, x) =>
        sum +
        x.Samples?.reduce(
          (s, one) =>
            s +
            (one.Standard?.filter(std => std.Result === "OK" || std.Result === "NA").length || 0),
          0
        ),
      0
    ) || 0;

    return { Accuracy: `${passed} / ${total}`, Percentage: total > 0 ? ((passed / total) * 100).toFixed(2) + '%' : '0%' };
  }

  return (
    < >

      {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}

      {/* <div className='text-center' >
        <p >{ChecksheetType} Report</p>
      </div> */}
      {/* <ToastContainer /> */}

      <div className="row">
        <div className='col-sm-3 mt-4'>
          <h5>
            Item Number: {obj.ItemNumber}{" "}
            {item.RefDocs && item.RefDocs.map((ref) => {
              return (
                <a
                  onClick={() => openBase64InNewTab(ref.FilePath)}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 'small', marginLeft: '10px' }}
                >
                  {ref.DocTitle}
                </a>
              );
            })}
          </h5>
        </div>
        {/* {config && config.ImageCapture && config.ImageCapture == 'enable' && <MultipleImageUploadWithRemarks ImageUpload={(data) => setImageURL(data)} />} */}
        {config?.CustomFields && config?.CustomFields.length > 0 && config?.CustomFields?.filter(x => x.DataType != "time_based_input" && x.DataType !== "Default").filter(x => (!x.Constant)).map((item, indext) =>
          item.DataType !== 'list' ?
            item.DataType == "high_speed_string" ?
              <HighSpeedDataType

                indext={indext}
                config={config}
                handleFocusNext={handleFocusNext}
                inputRefs={inputRefs}
                field={item}
                value={getCarryValue(item, '')}
                getString={(string) => handleOnChange(item.FieldName, string, indext)}
              />
              :
              item.DataType == "float" ?
                <div className='col-sm-3 mt-4'>
                  <div className="form-group "><label className='small d-flex mb-0'>{item.FieldName}{item.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
                    <input className='form-control form-control-sm' name={item.FieldName} type={"number"} value={getCarryValue(item, '')}
                      ref={(el) => (inputRefs.current[`${indext}-custom`] = el)}  // Store ref
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          const keys = Object.keys(inputRefs.current)
                          const currentIdx1 = keys.findIndex(x => x == `${indext}-custom`);
                          const nexKey = keys[currentIdx1 + 1];
                          handleFocusNext(nexKey);
                          // const isLastField = indext === config.CustomFields.length - 1;

                          // // Find the next non-select input field
                          // let nextIndex = indext + 1;
                          // while (nextIndex < config.CustomFields.length && config.CustomFields[nextIndex].DataType === 'list') {
                          //   nextIndex++; // Skip the select fields
                          // }

                          // if (isLastField && config.SampleSerial === "Manual") {
                          //   handleFocusNext(`${0}Parent`);  // Move to the parent if last field
                          // } else if (isLastField) {
                          //   // Move focus to the first input of the next section (e.g., `1-0`)
                          //   handleFocusNext(`0-0`);
                          // } else if (nextIndex < config.CustomFields.length) {
                          //   // Focus on the next input field (skipping select)
                          //   handleFocusNext(`0-${nextIndex}-${config.CustomFields[nextIndex].DataType === 'float' ? 'float' : 'text'}`);
                          // }
                        }
                      }}

                      step="0.01" onChange={(values) => { handleOnChange(item.FieldName, values.currentTarget.value, indext) }} placeholder={'Enter ' + item.FieldName} />
                    {errors && errors[item.FieldName] ? <p className='small text-danger'>{errors[item.FieldName]}</p> : <></>}
                  </div>
                </div> :
                <div className='col-sm-3 mt-4 '>
                  <div className="form-group d-flex-"><label className='small d-flex mb-0'>{item.FieldName}{item.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
                    <input className='form-control form-control-sm' name={item.FieldName} value={getCarryValue(item, '')}
                      ref={(el) => (inputRefs.current[`${indext}-custom`] = el)}  // Store ref
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          const keys = Object.keys(inputRefs.current)
                          const currentIdx1 = keys.findIndex(x => x == `${indext}-custom`);
                          const nexKey = keys[currentIdx1 + 1];
                          handleFocusNext(nexKey);
                        }
                      }}

                      type={item.DataType === 'string' ? 'text' : item.DataType} onChange={(values) => { handleOnChange(item.FieldName, values.currentTarget.value, indext) }} placeholder={'Enter ' + item.FieldName} />
                    {errors && errors[item.FieldName] ? <p className='small text-danger'>{errors[item.FieldName]}</p> : <></>}
                  </div>
                </div> :
            <div className='col-sm-3 mt-4'>
              <label className='small d-flex mb-0'>{item.FieldName}{item.Compulsory && <p style={{ height: 5 }} className='text-danger '>*</p>}</label >
              <Select
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const keys = Object.keys(inputRefs.current)
                    const currentIdx1 = keys.findIndex(x => x == `${indext}-custom`);
                    const nexKey = keys[currentIdx1 + 1];
                    handleFocusNext(nexKey);
                  }
                }}
                ref={(el) => (inputRefs.current[`${indext}-custom`] = el)}
                mode={getListValues(item).isMulti ? "multiple" : ''}
                className='form-control form-control-sm m-0 '
                placeholder={"Select " + item.FieldName}
                value={getCarryValue(item, [])}
                //value={inputData[item.FieldName]}
                onChange={(values) => {
                  handleOnChange(item.FieldName, values, indext)
                }}
                style={{ width: '100%' }}
                options={getListValues(item).options}
              />
              {errors && errors[item.FieldName] ? <p className='small text-danger'>{errors[item.FieldName]}</p> : <></>}
            </div>
        )}
        {constantFields && constantFields.length > 0 && constantFields.map((item, indext) =>
          item.DisplayForDataEntry && <div className='col-sm-3 mt-4 text-center'>
            <div style={{ height: 18 }} className='row text-left ml-1'>
              <label className='small'>{item.FieldName}</label >
            </div>
            <div className='row'>
              <div className="form-group ">
                <input value={item.Value || ""} className='form-control form-control-sm' name={item.FieldName} type={"text"} disabled />
              </div>

            </div>

          </div>
        )}

      </div>
      <div className='row'>
        {getRefrenceSpecimen()}
      </div>
      <div className='row'>
        {config?.DateTime == "Manual" && <div className='col-sm-3 mt-2'>
          Date &nbsp;:&nbsp; <input value={inputData.DateTime ? moment(inputData.DateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChangeDateTime('date', e.currentTarget.value)} type='date' />
        </div>}
        {config?.DateTime == "Manual" && <div className='col-sm-3 mt-2'>
          Time &nbsp;:&nbsp; <input value={inputData.DateTime ? moment(inputData.DateTime).format('HH:mm') : moment().format('HH:mm')} className='form-control form-control-sm' onChange={(e) => handleOnChangeDateTime('time', e.currentTarget.value)} type='time' />
        </div>}
        {/* <div className='col-sm-3 mt-2'>
          <label>Instrument Type : </label>
          <Select
            // maxTagCount='responsive'
            //mode="multiple"
            placeholder="Select Type"
            value={inputData.InstrumentType || []}
            onChange={(values) => {
              const data={...inputData}
              data.InstrumentType=values
              setInputData(data)
            }}
            style={{ width: '100%' }}
            options={types}
          />
        </div> */}
        {config && config?.ImageCapture && config?.ImageCapture == 'enable' &&
          <div className='col-sm-2 mt-4'>
            <MultipleImageUploadWithRemarks refDocs={imageURL} ImageUpload={(data) => setImageURL(data)} />
          </div>}
        {config?.InstrumentReq == "enable" && <div className='col-sm-4 mt-2'>
          <label>Instrument : </label>
          <Select
            // maxTagCount='responsive'
            mode="multiple"
            placeholder="Select Instrument"
            value={inputData.Instrument.map(x => { return { label: x.Instrument, value: x.Instrument } }) || []}
            onChange={(values, all) => {
              const data = { ...inputData }
              data.Instrument = all.map(x => { return { Instrument: x.label, InstrumentType: x.type } })
              setInputData(data)
            }}
            style={{ width: '100%' }}
            options={instruments}
          // options={instruments.filter((x)=>x.type==inputData.InstrumentType)}
          />
        </div>}
      </div>
      <div className='relative' style={{ marginBottom: '200px' }}>
        <div className="accordion mt-2" id="accordionParent">
          {qualityData.map((checksheet, index) => AccordianComp(checksheet.Drawing, checksheet.CheckSheetName, checksheet.TemplateName, index, checksheet.Samples))}
          <div className='mx-1 float-right align-items-center fw-bolder mt-1 '>
            <button className='btn-sm btn-primary' onClick={() => {
              if (config.ApprovalReq == "No") {
                handleOnSubmit("Closed")
              } else {
                if (location.state.obj && location.state.obj.State == "Closed") {
                  handleOnSubmit("Closed")
                } else {
                  handleOnSubmit("PendingApproval")
                }
              }
            }}>Submit Report</button>
          </div>
        </div>
        {/* {YourComponent()} */}
        {/* </div> */}



        <div className="Inspection-floatingcard  d-flex align-items-center p-2" style={{ position: 'fixed', width: '100%', bottom: 0, height: '9vh' }}>
          <div style={{ width: "100%" }} className='d-flex justify-content-between  '>
            {config.ShowAccuracyResult == "Yes" ?
              <div style={{ width: "45%" }} className='d-flex '>
                <div className='mx-3 fs-5 d-flex align-items-center fw-bolder'>
                  Accuracy Inspected: {finalAccuarcy().Accuracy} <br />
                  Done / Total as per Std

                </div >
                <div className='mx-3 fs-5 d-flex align-items-center fw-bolder' >
                  Accuracy (%) : {finalAccuarcy().Percentage} <br />
                  OK / Total Inspected
                </div>
              </div>
              :
              <div style={{ width: "45%" }} className='d-flex '>
                {console.log(FinalResult, "sdousoi", (FinalResult.filter(one => one.Value === 'OK')).length)}
                <div className='mx-3 fs-5 d-flex align-items-center fw-bolder'>
                  Items Inspected: {FinalResult.reduce((total, x) => total + x.length, 0)}/{NumberOfSample && Enable ? totalSampleWhenSetEnable() : NumberOfSample} <br />
                  Done / Total as per Std

                </div >
                <div className='mx-3 fs-5 d-flex align-items-center fw-bolder' >
                  Result : {FinalResult.reduce((total, x) => total + x.length, 0) > 0 && (FinalResult.reduce((total, x) => total + x.filter(one => one.Value === 'OK').length, 0))}/{FinalResult.reduce((total, x) => total + x.length, 0)}<br />
                  OK / Total Inspected
                </div>
              </div>}

            <div style={{ width: "45%" }} className='  '>
              <div className='desktop-only mt-3' >
                <div className='d-flex'>
                  {/* <div className='mx-1 d-flex align-items-center fw-bolder'>
                    <button className='btn-sm btn-primary' > Save</button>

                  </div > */}
                  <div className='mx-1 d-flex align-items-center fw-bolder' >
                    <button className='btn-sm btn-warning' onClick={() => history.goBack()}> Exit Without Saving</button>
                  </div>
                  {
                    config?.EnableSave == "enable" && location.state.obj && location.state.obj.State !== "Closed" && <div className='mx-1 d-flex align-items-center fw-bolder' >
                      <button className='btn-sm btn-info' onClick={() => handleOnSubmit("Preparing")}> Save Draft</button>
                    </div>
                  }
                </div>
              </div>
              <div className='mobile-only'>
                {
                  config?.EnableSave == "enable" && location.state.obj && location.state.obj.State !== "Closed" && <div className='mx-1 d-flex align-items-center fw-bolder' >
                    <button className='btn-sm btn-info' onClick={() => handleOnSubmit("Preparing")}> Save Draft</button>
                  </div>
                }
                {/* <div className='mt-1 d-flex align-items-center fw-bolder' >
                  <button className='btn-sm btn-primary' onClick={() => handleOnSubmit()}> Submit</button>


                </div> */}
                <div className='mt-1 d-flex align-items-center fw-bolder' >
                  <button className='btn-sm btn-warning' onClick={() => history.goBack()}> Exit Without Saving</button>


                </div>
              </div>


            </div>
          </div>

        </div>
      </div>

      <Modal
        title="Selected Image"
        visible={isModalVisible}
        onCancel={handleModalClose}
        footer={[
          <Button
            key="close"
            onClick={
              handleModalClose
            }
          >
            Close
          </Button>,
        ]}
      >
        {ModalImage && (
          <img
            src={ModalImage}
            alt="Selected"
            style={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        )}
      </Modal>
    </>
  );
}

export default MainReport;


